import { render } from "./UploadingStatus.vue?vue&type=template&id=c35a1218&scoped=true&ts=true"
import script from "./UploadingStatus.vue?vue&type=script&lang=ts"
export * from "./UploadingStatus.vue?vue&type=script&lang=ts"

import "./UploadingStatus.vue?vue&type=style&index=0&id=c35a1218&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c35a1218"]])

export default __exports__